/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Manual_Barcode_PlaceholderInputs */

const vi_mobile_manual_barcode_placeholder = /** @type {(inputs: Mobile_Manual_Barcode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập mã vạch thủ công...`)
};

/**

* @param {Mobile_Manual_Barcode_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const mobile_manual_barcode_placeholder = /** @type {((inputs?: Mobile_Manual_Barcode_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Manual_Barcode_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_mobile_manual_barcode_placeholder(inputs)
});